import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../styles/AboutPage.scss";

function useScrollAnimation(threshold = 0.3) {
  const elRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold }
    );

    if (elRef.current) obs.observe(elRef.current);
    return () => obs.disconnect();
  }, [threshold]);

  return [elRef, visible];
}

const Section = ({ children, className = "" }) => {
  const [ref, visible] = useScrollAnimation();
  return (
    <div ref={ref} className={`${className} ${visible ? "visible" : ""}`}>
      {children}
    </div>
  );
};

export default function AboutPage() {
  return (
    <section className="about-page py-5">
      <Container>
        <Section className="text-center section-header slide-up mb-5">
          <h2>Sobre a Termalhydro Aquecimento</h2>
          <p>
            A Termalhydro é especializada em soluções completas de aquecimento e
            climatização, atuando com excelência em projetos residenciais,
            comerciais e industriais.
          </p>
        </Section>

        <Section className="mission-section pop-in mb-5">
          <Row>
            <Col md={6}>
              <h3>Nossa Missão</h3>
              <p>
                Oferecer serviços que superem expectativas, promovendo conforto,
                sustentabilidade e confiança por meio de soluções sob medida com
                alta qualidade e segurança.
              </p>
            </Col>
            <Col md={6}>
              <h3>Nosso Diferencial</h3>
              <ul>
                <li>Equipe capacitada em elétrica e hidráulica</li>
                <li>Atendimento personalizado</li>
                <li>Inovação e materiais de ponta</li>
                <li>Compromisso com normas técnicas</li>
              </ul>
            </Col>
          </Row>
        </Section>

        <Section className="process-section mb-5 pop-in">
          <h3>Como Funciona Nosso Processo</h3>
          <ol>
            <li>
              <strong>Primeiro Contato:</strong> Atendimento via WhatsApp,
              e-mail ou Instagram.
            </li>
            <li>
              <strong>Visita Técnica:</strong> Avaliação no local com medições e
              diagnóstico.
            </li>
            <li>
              <strong>Orçamento Detalhado:</strong> Incluindo peças, etapas e
              opções de compra.
            </li>
            <li>
              <strong>Flexibilidade:</strong> Cliente pode comprar ou deixamos
              tudo pronto.
            </li>
            <li>
              <strong>Execução:</strong> Início do projeto com qualidade e
              agilidade.
            </li>
          </ol>
        </Section>

        <Section className="suppliers-section mb-5 pop-in">
          <h3>Fornecedores</h3>
          <p>
            Trabalhamos com fornecedores renomados para garantir qualidade e
            preço justo. O cliente pode:
          </p>
          <ul>
            <li>Realizar a compra direta através de links personalizados</li>
            <li>Solicitar nossa intermediação na aquisição</li>
          </ul>
          <p>
            Isso garante acesso direto à garantia dos produtos e suporte do
            fabricante.
          </p>
        </Section>

        <Section className="services-section mb-5 pop-in">
          <h3>Serviços Oferecidos</h3>
          <Row>
            <Col md={6}>
              <ul>
                <li>Instalação de sistemas solares e bombas de calor</li>
                <li>Troca de boilers, pressurizadores, placas solares</li>
                <li>
                  Instalação de banheiras, sistemas elétricos e hidráulicos
                </li>
                <li>Reparo de vazamentos e revisão preventiva</li>
              </ul>
            </Col>
            <Col md={6}>
              <ul>
                <li>Manutenção de aquecedores, bombas e pressurizadores</li>
                <li>Programação de controladores e sensores</li>
                <li>Instalação e manutenção de placas tubo a vácuo e planas</li>
                <li>Manutenção de sistemas a gás e piscinas</li>
              </ul>
            </Col>
          </Row>
        </Section>

        <Section className="products-section mb-5 pop-in">
          <h3>Produtos</h3>
          <p>Trabalhamos com uma linha completa:</p>
          <ul className="columns">
            <li>Pressostatos, Fluxostatos, Bombas de Circulação</li>
            <li>Placas Solares, Tubos a Vácuo, Boilers</li>
            <li>Aquecedores a Gás, Elétricos e Bombas de Calor</li>
            <li>Termostatos, Controladoras, Sensores</li>
            <li>Chuveiros, Torneiras e Kits de Instalação</li>
          </ul>
        </Section>

        <Section className="text-center mt-4 pop-in">
          <a
            href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seu+trabalho.`}
            target="_blank"
            style={{ color: "inherit" }}
          >
            <Button variant="primary">Fale com a Termalhydro</Button>
          </a>
        </Section>
      </Container>
    </section>
  );
}
